const fn = (el, binding) => {
  el.style.whiteSpace = "nowrap";
  el.textContent = binding.value?.text;
  const text = binding.value?.text;
  // 获取容器宽度
  const containerWidth = el.offsetWidth;
  // 超出多少行省略
  const lines = binding.value?.lines || 2;
  // 获取文本宽度
  const textWidth = el.scrollWidth;
  if (textWidth <= containerWidth * lines) {
    el.style.whiteSpace = "break-spaces";
    return;
  }
  if (!text) {
    return;
  }
  // 单行可以显示的文本个数
  const visibleChars = Math.floor(containerWidth / 16);

  const container = document.createElement("div");
  container.style.display = "flex";
  container.style.flexDirection = "column";
  container.style.width = "100%";
  container.style.overflow = "hidden";

  const startSpan = document.createElement("span");
  startSpan.textContent = text.substring(0, visibleChars + 2);
  startSpan.style.width = "auto";
  startSpan.style.whiteSpace = "nowrap";
  startSpan.style.overflow = "hidden";
  startSpan.style.textOverflow = "ellipsis";
  startSpan.style.flexShrink = "0"; // 从左向右显示

  container.appendChild(startSpan);
  const endContainer = document.createElement("div");
  endContainer.style.display = "flex";
  endContainer.style.flexDirection = "column";
  endContainer.style.width = "100%";

  const textArr = text.split("").reverse();
  for (let i = 0; i < lines - 1; i++) {
    const span = document.createElement("span");

    span.textContent = textArr
      .slice(visibleChars * i, visibleChars * (i + 1))
      .reverse()
      .join("");

    span.style.width = "auto";
    span.style.whiteSpace = "nowrap";
    span.style.overflow = "hidden";
    span.style.flexShrink = "0";
    span.style.textAlign = "left";
    endContainer.prepend(span);
  }

  el.textContent = "";
  el.appendChild(container);
  el.appendChild(endContainer);
};

/**
 * 中间省略指令
 * @directive 内容单行中间省略
 */
export function middleEllipsisMulti(app) {
  app.directive("middleEllipsisMulti", {
    mounted(el, binding) {
      fn(el, binding);
    },
  });
}
